import React, {cloneElement} from 'react';
import {IListActionsProps} from '../consts/interfaces/Interfaces';
import {ListButton, TopToolbar} from 'react-admin';
import {sanitizeListRestProps} from 'ra-core';

const BaseListActions = (props: IListActionsProps, ...rest) => {
   const {className, filters, resource, showFilter, displayedFilters, filterValues, basePath, total, currentSort, permanentFilter} = props;
   return (
      <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
         {filters &&
            cloneElement(filters, {
               resource,
               showFilter,
               displayedFilters,
               filterValues,
               basePath,
               context: 'button'
            })}
         <ListButton disabled={total === 0} resource={resource} sort={currentSort} filter={{...filterValues, ...permanentFilter}} basePath={basePath} />
      </TopToolbar>
   );
};
BaseListActions.defaultProps = {
   selectedIds: [],
   onUnselectItems: () => null
};

export default BaseListActions;
